export default "__VITE_ASSET__Cm5CTuvj__"